import { resolveComponent as _resolveComponent, createVNode as _createVNode, Suspense as _Suspense, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AppHomeView = _resolveComponent("AppHomeView")!
  const _component_pay_continue = _resolveComponent("pay-continue")!
  const _component_welcome_message = _resolveComponent("welcome-message")!
  const _component_about_event = _resolveComponent("about-event")!
  const _component_AppMainSpeakers = _resolveComponent("AppMainSpeakers")!
  const _component_SpeakersLoadingHome = _resolveComponent("SpeakersLoadingHome")!
  const _component_ticket_types_event = _resolveComponent("ticket-types-event")!
  const _component_program_preview = _resolveComponent("program-preview")!
  const _component_ProgramLoadingHome = _resolveComponent("ProgramLoadingHome")!
  const _component_sponsors_details = _resolveComponent("sponsors-details")!
  const _component_SponsorLoadingHome = _resolveComponent("SponsorLoadingHome")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_AppHomeView),
    _createVNode(_component_pay_continue),
    _createVNode(_component_welcome_message),
    _createVNode(_component_about_event),
    (_openBlock(), _createBlock(_Suspense, null, {
      fallback: _withCtx(() => [
        _createVNode(_component_SpeakersLoadingHome)
      ]),
      default: _withCtx(() => [
        _createVNode(_component_AppMainSpeakers)
      ]),
      _: 1
    })),
    _createVNode(_component_ticket_types_event),
    (_openBlock(), _createBlock(_Suspense, null, {
      fallback: _withCtx(() => [
        _createVNode(_component_ProgramLoadingHome)
      ]),
      default: _withCtx(() => [
        _createVNode(_component_program_preview)
      ]),
      _: 1
    })),
    (_openBlock(), _createBlock(_Suspense, null, {
      fallback: _withCtx(() => [
        _createVNode(_component_SponsorLoadingHome)
      ]),
      default: _withCtx(() => [
        _createVNode(_component_sponsors_details)
      ]),
      _: 1
    }))
  ]))
}